import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["breakpoints", "gutterWidth", "lookAhead", "itemsPerSlide", "maxItems"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useMemo } from 'react';
import useBreakpoints from 'hooks/useBreakpoints';
import getBreakpointValue from 'utils/ui/getBreakpointValue';
import Carousel from './Carousel';
import { jsx as _jsx } from "react/jsx-runtime";
function ResponsiveCarousel(_ref) {
  var breakpoints = _ref.breakpoints,
    gutterWidth = _ref.gutterWidth,
    lookAhead = _ref.lookAhead,
    itemsPerSlide = _ref.itemsPerSlide,
    maxItems = _ref.maxItems,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useBreakpoints = useBreakpoints(breakpoints),
    currentBreakpoint = _useBreakpoints.currentBreakpoint;

  /**
   * We memoize the calculation of the Carousel props.
   * This prevents the child Carousel from re-rendering unless
   * the actual active breakpoint or underlying data changes.
   */
  var carouselProps = useMemo(function () {
    var _ref2, _ref3, _getBreakpointValue, _getBreakpointValue2;
    // We use a fallback to ensure baseGutter and baseItems are never undefined
    var baseGutter = (_ref2 = Array.isArray(gutterWidth) ? gutterWidth[0] : gutterWidth) !== null && _ref2 !== void 0 ? _ref2 : 'none';
    var baseItems = (_ref3 = Array.isArray(itemsPerSlide) ? itemsPerSlide[0] : itemsPerSlide) !== null && _ref3 !== void 0 ? _ref3 : 1;
    return _objectSpread(_objectSpread({}, otherProps), {}, {
      gutterWidth: (_getBreakpointValue = getBreakpointValue(gutterWidth, breakpoints, currentBreakpoint)) !== null && _getBreakpointValue !== void 0 ? _getBreakpointValue : baseGutter,
      itemsPerSlide: (_getBreakpointValue2 = getBreakpointValue(itemsPerSlide, breakpoints, currentBreakpoint)) !== null && _getBreakpointValue2 !== void 0 ? _getBreakpointValue2 : baseItems,
      lookAhead: getBreakpointValue(lookAhead, breakpoints, currentBreakpoint),
      maxItems: getBreakpointValue(maxItems, breakpoints, currentBreakpoint)
    });
  }, [otherProps, breakpoints, currentBreakpoint, gutterWidth, itemsPerSlide, lookAhead, maxItems]);
  return /*#__PURE__*/_jsx(Carousel, _objectSpread({}, carouselProps));
}
ResponsiveCarousel.displayName = 'ResponsiveCarousel';
export default ResponsiveCarousel;